import { gql } from "lib/apolloClient";
export const getOrganizationSubjectsBasicDetailsQuery = gql`
  query getOrganizationSubjectsAssociations(
    $id: ID!
    $filters: SubjectFilterInput
    $subjectCourseFilter: SubjectCourseFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $filters) {
          id
          name
          icon
          iconType
          grades {
            id
            name
          }
          unitPlans {
            totalCount
          }
          courses(filters: $subjectCourseFilter) {
            totalCount
          }
          tags {
            id
            key
            value
          }
          isArchived
          metadata
        }
      }
    }
  }
`;
